// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"54bb6630","192":"ee213118","197":"bfe6b0b4","525":"2f23f2f9","567":"2919a6dd","930":"d27fd98e","965":"67f8c5c4","990":"eafe75dd"}[chunkId] + ".chunk.js";
};